import { Switchboard } from "../../../events";
import $ from 'jquery';
export class ToolbarButton {
    constructor(icon, description, id) {
        this.icon = icon;
        this.description = description;
        this.id = id;
        this.bound_contexts = [];
        this.receiver = Switchboard.get_receiver("CONTEXT");
        this.broadcaster = Switchboard.get_emitter("INTERACTION");
        this.ui = this.create_ui();
        this.receiver.on('ctx_change', (new_context) => {
            if (this.visible_in(new_context))
                this.ui.removeClass('hidden');
            else
                this.ui.addClass('hidden');
        });
    }
    exit_actions() {
        this.broadcaster.emit('i_request', '');
    }
    bind(...ctxs) {
        for (let c of ctxs) {
            this.bound_contexts.push(c);
        }
        return this;
    }
    visible_in(ctx) {
        return this.bound_contexts.length > 0 ? this.bound_contexts.includes(ctx.name) : true;
    }
    create_ui() {
        const btn = $(`<button id="${this.id}"></button>`);
        const img = $(`<i class='fas fa-${this.icon}' title='${this.description}'></i>`);
        btn.append(img);
        btn.on('click', () => {
            btn.toggleClass("highlighted");
            this.exit_actions();
            this._action();
        });
        return btn;
    }
}
